export function addressFieldsToCompactAddress(address: any): string {
    return `${address['street']},${address['civic']} (${address['city']} - ${address['postalCode']})`
}